module.exports = __webpack_public_path__ + "img/UBQ.5efab599.svg";